import React, { Fragment } from "react"
import { connect } from "react-redux"
import { bindActionCreators, compose } from "redux"
import { withRouter } from "react-router-dom"
import { isEmpty } from "lodash"
import history from "app/history"

import LazyLoadWrapper from "components/common/LazyLoadWrapper"
import PageContainer from "components/common/PageContainer"
import Button from "components/common/Button"
import CardList from "components/common/CardList"
import CustomModal from "components/common/CustomModal"
import StatementModal from "components/common/StatementModal"
import Alert from "components/common/Alert"
import MediaPlayer from "components/common/MediaPlayer"

import { showAuthModal } from "store/auth/action"
import { fetchCourseById, fetchSimilarCourses } from "store/courses/action"
import {
  amountFormatter,
  renderIconFileTypes,
  formatDuration,
  isIdVerified,
} from "helpers/util"
import { AUTH_TYPES, ADMIN_ROLE } from "constants/auth-types"
import { CUSTOM_MODAL_TYPES, RESPONSE_MODAL_TYPES } from "constants/modal-types"
import { STATEMENT_CONTENT } from "constants/message"

import {
  courseEnrollment,
  startCourse,
  showResponseModal,
  closeResponseModal,
  showConfirmModal,
  closeConfirmModal,
} from "store/user/actions"

import { resendEmail } from "store/auth/action"

import "styles/components/common/accordion.scss"
import "styles/pages/course.scss"
import "react-lazy-load-image-component/src/effects/blur.css"
import { MODAL_MESSAGES } from "constants/message"
import { GOOGLE_SITE_KEY } from "constants/config"

class CourseDetails extends React.Component {
  constructor() {
    super()
    this.state = {
      customModalState: false,
      modalType: CUSTOM_MODAL_TYPES.BASIC,
      isEnrolled: false,
      showAffirmationModal: false,
      activeTab: 0,
      enrollmentType: "",
    }
  }

  componentDidMount() {
    const {
      location: { pathname, search },
      fetchCourseById,
      fetchSimilarCourses,
      showResponseModal,
      closeResponseModal,
    } = this.props

    let currentPath = pathname.split("/")
    if (currentPath[1] === "course" && !isEmpty(currentPath[2])) {
      let id = currentPath[2].split(/[\s-]+/).pop()
      fetchCourseById(id)
      fetchSimilarCourses(id)
    }

    let value = search.split("=")
    let modalData = {
      verified: true,
      actionLabel: "OK",
      action: () => closeResponseModal(),
    }
    switch (value[1]) {
      case "S":
        modalData.header = "Payment Successful"
        modalData.modalType = RESPONSE_MODAL_TYPES.SUCCESS
        modalData.message = MODAL_MESSAGES.PAYMENT_COMPLETE
        showResponseModal(modalData)
        break

      case "P":
      case "V":
        modalData.header = "Payment Pending"
        modalData.modalType = RESPONSE_MODAL_TYPES.WARNING
        modalData.message = MODAL_MESSAGES.PAYMENT_PENDING
        showResponseModal(modalData)
        break

      case "F":
        modalData.header = "Payment Failed"
        modalData.modalType = RESPONSE_MODAL_TYPES.ERROR
        modalData.message = MODAL_MESSAGES.PAYMENT_FAILED
        showResponseModal(modalData)
        break
      case "PLS":
        modalData.header = "Payment Successful"
        modalData.modalType = RESPONSE_MODAL_TYPES.SUCCESS
        modalData.message = MODAL_MESSAGES.PAYMENT_LATER_SUCCESS
        modalData.actionLabel = "View Certificate"
        modalData.showCloseModal = true
        showResponseModal(modalData)
        break

      case "PLP":
        modalData.header = "Payment Pending"
        modalData.modalType = RESPONSE_MODAL_TYPES.WARNING
        modalData.message = MODAL_MESSAGES.PAYMENT_LATER_PENDING
        modalData.actionLabel = "OK"
        showResponseModal(modalData)
        break
      default:
        break
    }
  }

  componentDidUpdate(prevProps) {
    const {
      location: { pathname: prevPathname },
    } = prevProps

    const {
      fetchCourseById,
      fetchSimilarCourses,
      location: { pathname },
    } = this.props

    if (pathname !== prevPathname) {
      let currentPath = pathname.split("/")
      if (currentPath[1] === "course" && !isEmpty(currentPath[2])) {
        let id = currentPath[2].split(/[\s-]+/).pop()

        fetchCourseById(id)
        fetchSimilarCourses(id)
      }
    }
  }

  displayCourseware(coursewares) {
    if (Array.isArray(coursewares)) {
      return (
        <React.Fragment>
          {coursewares.map((item) => (
            <div className="courseware-item" key={item.id}>
              <i className={renderIconFileTypes(item.type)} />
              <p className="title">{item.name}</p>
            </div>
          ))}
        </React.Fragment>
      )
    } else {
      return <p>N/A</p>
    }
  }

  customModalToggle = () => {
    this.setState((prevState) => ({
      customModalState: !prevState.customModalState,
    }))
  }

  showEnrollNow = (type) => {
    const {
      auth,
      courses: {
        selectedCourse: { fee, config, classes, slug },
      },
      user: { userDetails },
      school: { schoolData },
      showAuthModal,
    } = this.props

    const { config: schoolConfig = {} } = schoolData
    const schoolPrimaryId = schoolConfig?.products?.primary_id || false
    const userIdVerified = isIdVerified(userDetails?.user_ids, schoolPrimaryId)
    this.setState({ enrollmentType: type || "" })
    // const nextManualKYC = localStorage.getItem(`KYCManual-${userDetails.id}`)
    // const manualKYCSubmitted = nextManualKYC && moment().isBefore(nextManualKYC)
    if (!auth.isAuthorized) {
      showAuthModal({ type: AUTH_TYPES.LOGIN })
    } else if (!auth.userId) {
      this.setState({ modalType: CUSTOM_MODAL_TYPES.NOT_STUDENT })
      this.customModalToggle()
    } else if (!userDetails?.is_verified) {
      this.setState({ modalType: CUSTOM_MODAL_TYPES.VERIFY_EMAIL })
      this.customModalToggle()
    } else if (userDetails.step === "1") {
      this.setState({ modalType: CUSTOM_MODAL_TYPES.INC_PROFILE })
      this.customModalToggle()
    } else if (
      schoolData?.config?.products?.mcle &&
      !userDetails?.info_submitted
    ) {
      this.setState({ modalType: CUSTOM_MODAL_TYPES.INC_MCLE_PROFILE })
      this.customModalToggle()
    } else if (config?.require_kyc && !userIdVerified) {
      this.setState({ modalType: CUSTOM_MODAL_TYPES.INC_KYC })
      this.customModalToggle()
    } else if (schoolData?.config?.products?.mcle) {
      this.affirmationModalToggle()
    } else if (config?.class_enrollment_only) {
      if (isEmpty(classes)) {
        this.setState({ modalType: CUSTOM_MODAL_TYPES.NO_CLASS })
      } else {
        this.setState({ modalType: CUSTOM_MODAL_TYPES.SELECT_CLASS })
      }
      this.customModalToggle()
    } else if (config?.direct_enrollment) {
      if (fee === 0) {
        this.setState({ modalType: CUSTOM_MODAL_TYPES.TEXT })
        this.customModalToggle()
      } else if (type === "pay_later") {
        this.setState({ modalType: CUSTOM_MODAL_TYPES.PAY_LATER })
        this.customModalToggle()
      } else {
        history.push(`/course/payment/${slug}`)
      }
    }
  }

  showEnrollForFree = () => {
    this.setState(
      {
        enrollmentType: "pay_later",
      },
      () => {
        this.showEnrollNow("pay_later")
      }
    )
  }

  showPaymentPage = () => {
    const {
      courses: {
        selectedCourse: { fee, config, classes, slug },
      },
    } = this.props

    if (config?.class_enrollment_only) {
      if (isEmpty(classes)) {
        this.setState({ modalType: CUSTOM_MODAL_TYPES.NO_CLASS })
      } else {
        this.setState({ modalType: CUSTOM_MODAL_TYPES.SELECT_CLASS })
      }
      this.customModalToggle()
    } else if (fee === 0) {
      this.setState({ modalType: CUSTOM_MODAL_TYPES.TEXT })
      this.customModalToggle()
    } else {
      history.push(`/course/payment/${slug}`)
    }
  }

  onSubmitEnrollment = (data, isPayLater) => {
    const {
      courseEnrollment,
      school: { schoolData },
      courses: {
        selectedCourse: { id, config },
      },
    } = this.props
    const { config: schoolConfig = {} } = schoolData

    let freeCourseEnrollment = {
      course: id,
      action: "free",
      startDate: config?.date_start,
    }
    if (schoolConfig?.products?.mcle) {
      freeCourseEnrollment.compliance_period = data
    }
    if (isPayLater) {
      freeCourseEnrollment.action = "pay_later"
    }
    this.setState({ customModalState: false })
    courseEnrollment(freeCourseEnrollment)
  }

  handleCheckIfEnrolled = (id) => {
    const {
      courses: {
        selectedCourse: { config, enrollment, fee },
      },
      auth: { role },
    } = this.props

    let enrollmentDetails = {}
    if (enrollment) {
      if (enrollment.progress > 0 && enrollment.progress < 100) {
        enrollmentDetails.isEnrolled = true
        enrollmentDetails.label = "Resume Learning"
      } else if (
        enrollment.progress === 100 &&
        enrollment.status === "pay_later"
      ) {
        enrollmentDetails.isEnrolled = true
        enrollmentDetails.label = "View Course"
        enrollmentDetails.isGhostStyle = true
      } else if (enrollment.progress === 100) {
        enrollmentDetails.isEnrolled = true
        enrollmentDetails.label = "View Course"
      } else if (enrollment.status === "notpaid") {
        enrollmentDetails.isEnrolled = false
        enrollmentDetails.label = "Payment Pending"
      } else if (enrollment.status === "pay_later") {
        enrollmentDetails.isEnrolled = true
        enrollmentDetails.label = "Start Learning"
      } else {
        enrollmentDetails.isEnrolled = true
        enrollmentDetails.label = "Start Learning"
      }
    } else if (ADMIN_ROLE.includes(role)) {
      enrollmentDetails.isEnrolled = true
      enrollmentDetails.label = "View Course"
    } else if (config?.allow_pay_later && parseFloat(fee) > 0) {
      enrollmentDetails.isEnrolled = false
      enrollmentDetails.label = "Enroll and Pay now"
    } else {
      enrollmentDetails.isEnrolled = false
      enrollmentDetails.label = "Enroll Now"
    }
    return enrollmentDetails
  }

  confirmSnapshot(id) {
    const {
      courses: {
        selectedCourse: { config: courseConfig, slug, modules = [] },
      },
      school: {
        schoolData: { config: schoolConfig },
      },
      showConfirmModal,
      closeConfirmModal,
      auth: { role },
    } = this.props

    if (ADMIN_ROLE.includes(role)) {
      history.push(`/course/${slug}/module/${modules[0]?.coursewares[0]?.id}`)
    } else if (courseConfig.course_open) {
      if (courseConfig.enable_kyl) {
        let message = ""

        if (schoolConfig?.products?.mcle === true) {
          if (!courseConfig.video_download || !courseConfig.video_download) {
            message = (
              <p>
                A.M. 19-10-16-SC requires random photo validation and consent
                thereto. Also, please proceed with this course indoors, in a
                well-lit room to facilitate authentication. This content is only
                available for consumption on the platform. No part of this
                module may be captured, copied, stored, distributed, or
                otherwise used without permission.
              </p>
            )
          } else {
            message =
              "A.M. 19-10-16-SC requires random photo validation and consent thereto. Also, please proceed with this course indoors, in a well-lit room to facilitate authentication."
          }
        } else {
          if (!courseConfig.video_download || !courseConfig.video_download) {
            message = (
              <p>
                This course requires random photo validation and consent
                thereto. Also, please proceed with this course indoors, in a
                well-lit room to facilitate authentication. This content is only
                available for consumption on the platform. No part of this
                module may be captured, copied, stored, distributed, or
                otherwise used without permission.
              </p>
            )
          } else {
            message =
              "This course requires random photo validation and consent thereto. Also, please proceed with this course indoors, in a well-lit room to facilitate authentication."
          }
        }

        showConfirmModal({
          modalType: RESPONSE_MODAL_TYPES.WARNING,
          header: "GENERAL NOTICE",
          message: message,
          confirmLabel: "Continue",
          confirmAction: () => {
            this.startCourse(id)
            closeConfirmModal()
          },
        })
      } else {
        this.startCourse(id)
      }
    } else if (courseConfig.course_ended) {
      this.setState({ modalType: CUSTOM_MODAL_TYPES.COURSE_ENDED })
      this.customModalToggle()
    } else {
      this.setState({ modalType: CUSTOM_MODAL_TYPES.COURSE_NOT_OPEN })
      this.customModalToggle()
    }
  }

  startCourse = (id) => {
    const { startCourse } = this.props
    startCourse({ id: id })
  }

  isEnrollmentEnabled = () => {
    const {
      courses: { selectedCourse },
      user: {
        userDetails: { email },
      },
      auth: { role },
    } = this.props

    let isEnrollmentDisabled
    let userEmailDomain = email?.split("@").pop()

    if (
      (isEmpty(selectedCourse?.config?.allowed_domains) &&
        selectedCourse?.config?.direct_enrollment) ||
      ADMIN_ROLE.includes(role)
    ) {
      isEnrollmentDisabled = false
    } else if (
      (selectedCourse?.config?.allowed_domains?.includes(userEmailDomain) &&
        selectedCourse?.config?.direct_enrollment) ||
      ADMIN_ROLE.includes(role)
    ) {
      isEnrollmentDisabled = false
    } else {
      isEnrollmentDisabled = true
    }

    // if (selectedCourse?.enrollment?.status === "notpaid") {
    //   isEnrollmentDisabled = true;
    // }

    return isEnrollmentDisabled
  }

  handleModalAction = (data) => {
    const { modalType } = this.state
    if (modalType === CUSTOM_MODAL_TYPES.INC_PROFILE) {
      this.redirectToProfile()
    } else if (modalType === CUSTOM_MODAL_TYPES.INC_MCLE_PROFILE) {
      this.redirectToMCLEProfile()
    } else if (modalType === CUSTOM_MODAL_TYPES.INC_KYC) {
      this.redirectToProfileKYC()
    } else if (modalType === CUSTOM_MODAL_TYPES.VERIFY_EMAIL) {
      this.handleResendEmail()
    } else if (modalType === CUSTOM_MODAL_TYPES.PAY_LATER) {
      this.onSubmitEnrollment(data, true)
      this.customModalToggle()
    } else {
      this.onSubmitEnrollment(data)
    }
  }

  handleResendEmail = () => {
    window.grecaptcha.ready(() => {
      window.grecaptcha
        .execute(GOOGLE_SITE_KEY, { action: "submit" })
        .then((token) => {
          this.props.resendEmail({
            "g-recaptcha-response": token,
          })
        })
    })
  }

  checkMCLEStatus = () => {
    const {
      school: {
        schoolData: { config: schoolConfig },
      },
    } = this.props

    if (schoolConfig?.products?.mcle === true) {
      this.affirmationModalToggle()
    } else {
      this.showEnrollNow()
    }
  }

  affirmationModalToggle = () => {
    this.setState((prevState) => ({
      showAffirmationModal: !prevState.showAffirmationModal,
    }))
  }

  onChangeTab = (index) => {
    this.setState({
      activeTab: index,
    })
  }

  redirectToEmailProfile = () => {
    history.push("/student/email")
  }

  redirectToProfileKYC = () => {
    history.push("/student/authenticate-id")
  }

  redirectToMCLEProfile = () => {
    history.push("/student/mcle-profile")
  }

  redirectToProfile = () => {
    history.push("/student/profile")
  }

  renderMedia = (selectedCourse) => {
    const videoPreview = selectedCourse.preview_video
    const imagePreviewLink = selectedCourse.image
    const YT_URL = "https;//youtube.com/watch?v="
    if (isEmpty(selectedCourse.preview_video)) {
      return (
        <LazyLoadWrapper
          className="course-cover"
          src={`${imagePreviewLink}`}
          effect="blur"
          width="100%"
        />
      )
    } else {
      return (
        <MediaPlayer
          media={
            videoPreview?.type === "yt"
              ? YT_URL + `${videoPreview?.url}`
              : `${videoPreview?.url}`
          }
          type={videoPreview?.type}
          forwardStreaming={true}
          customStyle={{
            margin: "0px",
            display: "grid",
            gridColumn: "1/4",
            maxWidth: "100%",
            justifyContent: "unset",
            borderRadius: "0px",
            height: "100%",
          }}
        />
      )
    }
  }

  handleConfirmAffirmation = (data) => {
    if (data === "pay_later") {
      this.setState({ modalType: CUSTOM_MODAL_TYPES.PAY_LATER })
      this.customModalToggle()
    } else {
      this.showPaymentPage()
    }
    this.affirmationModalToggle()
  }

  render() {
    const {
      courses: {
        selectedCourse,
        similarCourses,
        isLoadingSimilarCourses,
        isLoadingSelectedCourse,
      },
      school: { schoolData },
    } = this.props

    const {
      customModalState,
      modalType,
      showAffirmationModal,
      enrollmentType,
    } = this.state
    let data = this.handleCheckIfEnrolled(selectedCourse.id)
    return (
      <PageContainer
        isPageLoading={isLoadingSelectedCourse}
        className="course-page"
      >
        <LazyLoadWrapper
          className="course-cover"
          src={`${selectedCourse.image}`}
          effect="blur"
          width="100%"
        />
        <div className="course-container">
          <div className="course-wrapper">
            {this.renderMedia(selectedCourse)}
            <div className="content-section">
              {selectedCourse.attempt?.ended &&
                selectedCourse.enrollment?.progress < 100 && (
                  <Alert
                    type="error"
                    header="Oops, Sorry!"
                    message={`Timer has ended and you weren't able to finish within the time allocated for this course.
                    Don't worry, you can retake the course, but your progress will be reset. Just click the Start
                    Learning button. You can also check the course requirements below.`}
                  />
                )}
              <h1 className="course-title">{selectedCourse.name}</h1>
              <h4 className="course-kicker">About this course</h4>
              <p className="course-description">{selectedCourse.description}</p>
              <h4 className="course-kicker">Course Overview</h4>
              <div className="course-overview">
                {selectedCourse?.modules?.map((item) => (
                  <div className="module-item" key={item.id}>
                    <p className="title">{item.name}</p>
                    <div className="courseware-list">
                      {this.displayCourseware(item.coursewares)}
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="course-info">
              <div className="info-container">
                <p className="fee">{`${
                  selectedCourse.fee
                    ? `P${amountFormatter(selectedCourse.fee)}`
                    : "FREE"
                }`}</p>
                <p className="course-label">Category</p>
                <p className="course-text">
                  <span className="icon-category" />
                  {selectedCourse?.category?.name}
                </p>
                {selectedCourse?.subcategory?.name && (
                  <>
                    <p className="course-label">Subcategory</p>
                    <p className="course-text">
                      <span className="icon-category" />
                      {selectedCourse?.subcategory?.name}
                    </p>
                  </>
                )}
                {selectedCourse?.lecturer && (
                  <>
                    <p className="course-label">Lecturer</p>
                    <p className="course-text">
                      <span className="icon-lecturer" />
                      {selectedCourse?.lecturer}
                    </p>
                  </>
                )}
                <p className="course-label">Modules</p>
                <p className="course-text">
                  <span className="icon-modules" />
                  {selectedCourse.module_count}{" "}
                  {selectedCourse.module_count > 1 ? "Modules" : "Module"}
                </p>
                <p className="course-label">Coursewares</p>
                <p className="course-text">
                  <span className="icon-courseware" />
                  {selectedCourse.courseware_count}{" "}
                  {selectedCourse.courseware_count > 1
                    ? "Coursewares"
                    : "Courseware"}
                </p>
                {selectedCourse?.units && (
                  <>
                    <p className="course-label">Units</p>
                    <p className="course-text">
                      <span className="icon-unit" />
                      {selectedCourse?.units}{" "}
                      {selectedCourse.units > 1 ? "Units" : "Unit"}
                    </p>
                  </>
                )}
                {selectedCourse?.config?.duration > 0 && (
                  <Fragment>
                    <p className="course-label">Course Duration</p>
                    <p className="course-text">
                      <span className="icon-timer" />
                      {formatDuration(selectedCourse?.config?.duration)}
                    </p>
                  </Fragment>
                )}
                {data.isEnrolled ? (
                  <>
                    {selectedCourse?.enrollment?.progress === 100 &&
                      selectedCourse?.enrollment?.status === "pay_later" && (
                        <Button
                          label={"Get Certificate"}
                          onClick={() => {
                            history.push(
                              `/course/payment/${selectedCourse?.slug}`
                            )
                          }}
                        />
                      )}
                    <Button
                      label={data.label}
                      ghost={data.isGhostStyle}
                      onClick={() => {
                        this.confirmSnapshot(selectedCourse.id)
                      }}
                    />
                  </>
                ) : (
                  <>
                    <Button
                      loading={isLoadingSelectedCourse}
                      disabled={this.isEnrollmentEnabled()}
                      label={data.label}
                      onClick={() => this.showEnrollNow()}
                    />
                    {isEmpty(selectedCourse?.enrollment) &&
                      selectedCourse?.config?.allow_pay_later && (
                        <Button
                          customClassName={"course-action"}
                          ghost
                          loading={isLoadingSelectedCourse}
                          disabled={this.isEnrollmentEnabled()}
                          label={"Enroll for Free"}
                          onClick={() => this.showEnrollForFree()}
                        />
                      )}
                  </>
                )}
              </div>
            </div>
          </div>
          <StatementModal
            isOpen={showAffirmationModal}
            closeModal={() => this.affirmationModalToggle()}
            title="Statement of Affirmation"
            consentLabel="I am confirming that I have read the Statement of Affirmation and agree to its contents."
            message={STATEMENT_CONTENT["AFFIRMATION"]}
            onConfirm={() => {
              this.handleConfirmAffirmation(enrollmentType)
            }}
          />
          <CustomModal
            type={modalType}
            isOpen={customModalState}
            closeModal={() => this.setState({ customModalState: false })}
            data={selectedCourse}
            handleModalAction={this.handleModalAction}
          />
        </div>
        <>
          {similarCourses && similarCourses.length ? (
            <div className="similar-course">
              <div
                className="courses-header"
                style={{ borderColor: schoolData.primary_color }}
              >
                <h3 className="headline">Similar courses</h3>
                <p className="explainer">
                  Here are some courses like this one.
                </p>
              </div>
              <CardList
                data={similarCourses}
                loading={isLoadingSimilarCourses}
              />
            </div>
          ) : null}
        </>
      </PageContainer>
    )
  }
}

const mapStateToProps = (state) => ({
  courses: state.coursesReducer,
  user: state.userReducer,
  auth: state.authReducer,
  school: state.schoolReducer,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchCourseById,
      fetchSimilarCourses,
      courseEnrollment,
      startCourse,
      resendEmail,
      showResponseModal,
      closeResponseModal,
      showConfirmModal,
      closeConfirmModal,
      showAuthModal,
    },
    dispatch
  )

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter
)(CourseDetails)
